import {SEISMIC_HOIST_TAG_NAME} from './constants';

export default function resolveContext(context) {
	const isSeismicElement = context.nowId;
	if (!isSeismicElement) return context;

	const resolvedHost = context.tagName === SEISMIC_HOIST_TAG_NAME ? context.sourceElement : context;

	return {
		componentName: resolvedHost.tagName,
		componentId: resolvedHost.nowId,
		parentComponentId: resolvedHost.__DO_NOT_USE_OR_YOU_WILL_BE_FIRED_BY_YOUR_PARENT__,
		metricTypes: resolvedHost.metricTypes,
		metricsLevel: resolvedHost.metricsLevel,
		ready: resolvedHost.__DO_NOT_USE_BOOTSTRAPPED__
	};
}
